/*
 *
 * CostsShopSelector
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 02-Oct-2025
*/

import { connect } from 'react-redux'
import CostsShopSelector from './CostsShopSelector'
import { doGetCostsShopList, doSetShopSearchTerm, doSetCostsShopLocalSelection } from 'Store/actions/shopPicker'
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = dispatch => ({
  doGetCostsShopList: (type) => dispatch(doGetCostsShopList(type)),
  doSetShopSearchTerm: (payload) => dispatch(doSetShopSearchTerm(payload)),
  doSetCostsShopLocalSelection: (payload) => dispatch(doSetCostsShopLocalSelection(payload))
})

const mapStateToProps = (state) => ({
  // Use costs-specific state
  shopSaved: nullSafe(() => state.shopPicker, []),
  shopLocalSelection: nullSafe(() => state.shopPicker.costsShopLocalSelection, {}),
  shopListLoading: nullSafe(() => state.userProfiling.shopListCostsLoading, false),
  shopSearchTerm: nullSafe(() => state.shopPicker.searchTerm, '')
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(CostsShopSelector)
